import React from "react";
import datajoltLoading from "../../assets/img/icons/Datajolt-Spinner.json";
import Lottie from "lottie-react";

export default function DatajoltSpinner() {
  return (
    <Lottie animationData={datajoltLoading} loop style={{ width: "100px" }} />
  );
}
